module.exports = ":host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%; }\n\n.btn-import, .btn-cancel {\n  margin-left: 2px; }\n\n.btn-cancel {\n  padding: .375rem 0.9rem; }\n\n.wrapper {\n  width: 100%; }\n\nng-select {\n  margin: 5px 0; }\n\n.ladda-button {\n  padding: .375rem 1.6rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/upload-assets/upload-assets.component.scss
// module id = ./src/app/components/upload-assets/upload-assets.component.scss
// module chunks = main